import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import QuickbetXLobbyComponent from "../Components/QuickbetXLobbyComponent";

interface STLProps {
    atagParams: string | null
    mode?: string | null
}
const QuickbetXLobby: FC <STLProps> = ({atagParams, mode}) => {
    const {getQuickbetsXData} = useAction();
    const {quickbetsXData} = useTypedSelector((state) => state.quickbetXsReducer);

    useEffect(()=>{
        getQuickbetsXData();
    }, [])
    return(
        <>
            {quickbetsXData.length > 0 ?
                <QuickbetXLobbyComponent mode={mode} data={quickbetsXData} atagParams={atagParams} />
                : null
            }
        </>
    )

}

export default QuickbetXLobby;
